import ReceptionistAPI from '../Clients/ReceptionistAPI'

const SubmitContact = async (values) => {
    try {
        await ReceptionistAPI.post('/messages', values)
        return { success: true }
    } catch (e) {
        return {
            error: e.message,
            code: e.response?.status,
            data: e.response?.data,
        }
    }
}

export default SubmitContact
